export const productCategoryObj = [
    {
        label: 'FG', value: 'FG'
    },{
        label: 'SPARE', value: 'SPARE'
    }
  ]

  export const formatValueWithCommas = (value) => {
    // if (value > 99999) {
    //     const lakhs = Math.floor(value / 100000); // Get the number of lakhs
    //     const remainingThousands = value % 100000; // Get the remaining thousands
    //     const formattedValue = lakhs.toLocaleString('en-IN') + ',' + remainingThousands.toLocaleString('en-IN'); // Format as lakhs and remaining thousands
    //     return formattedValue;
    // } else {
        // Use default formatting for values less than or equal to 99999
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // }
};